"use client";

import type { ProductDetails } from "@/lib/centra";
import { addLeadingSlash } from "@frend-digital/utils";
import React from "react";

/**
 * ReviewList Component
 *
 * Renders a product review list with conditional size question display.
 * The size question ("Is this the correct size?") only appears when there are
 * existing votes in the LipScore product attributes.
 *
 * @param product - Product details from Centra
 * @param slug - URL path segments for the product
 */

export const ReviewList = ({ product, slug }: { product: ProductDetails; slug: string[] }) => {
	return (
		<>
			<div
				id="lipscore-review-list"
				data-ls-product-name={product.name}
				data-ls-brand={product.brand}
				data-ls-product-id={product.centraProductNumber}
				data-ls-product-url={`https://vikingfootwear.com${addLeadingSlash(slug.join("/"))}`}
				data-ls-variant-id={product.displayItemId}
				data-ls-variant-name={product.variantName}
				data-ls-sku={product.sku}
				data-ls-description={product.shortDescription}
				data-ls-image-url={product.media.at(0)?.href}
				data-ls-price={product.priceAsNumber}
				data-ls-price-currency={product.price?.match(/[A-Z]{3}$/)?.[0]}
				data-ls-category={product.canonicalCategoryUri}
				className="lipscore-review-list-container"
			/>
		</>
	);
};
